// extracted by mini-css-extract-plugin
export default {"LinkButton":"LinkButton_LinkButton__dlcS6","Orange":"LinkButton_Orange__wi8uD","Blue":"LinkButton_Blue__N+wS0","Purple":"LinkButton_Purple__VIq33"};